<!-- Single template with dynamic content based on submission mode -->
<ng-container [ngSwitch]="gameDetails.SubmissionMode">
  <!-- Login/Register Template -->
  <div *ngSwitchCase="0" class="auth-container">
    <h2 class="submission-title">{{ 'fgbcl.games.external.form.login.or.register' | translate }}</h2>
    <p class="submission-description text-center">
      {{ 'fgbcl.games.external.form.description' | translate }}
    </p>
    <div 
      class="terms-conditions-checkbox pl-1"
      [ngClass]="{ 'terms-checkbox-checked': termsAccepted }"
    >
      <input type="checkbox" id="acceptTerms" class="terms-checkbox" [(ngModel)]="termsAccepted"/>
      <label for="acceptTerms" class="accept-terms-label">{{ 'fgbcl.games.external.form.accept.terms' | translate }}</label>           
    </div>
    <div class="auth-container">
      <button class="auth-login-button" (click)="navigateToLogin()" [disabled]="!termsAccepted" [class.auth-login-button--disabled]="!termsAccepted">{{ 'fgbcl.games.external.form.login.btn' | translate }}</button>
      <button class="auth-register-button" (click)="navigateToRegistration()" [disabled]="!termsAccepted" [class.auth-register-button--disabled]="!termsAccepted">{{ 'fgbcl.games.external.form.register.btn' | translate }}</button>
    </div>
  </div>

  <!-- Login + Form Template -->
  <div *ngSwitchCase="1" class="auth-form-container">
    <h2 class="submission-title text-center">
      {{
        unauthorizedEntityCreated
          ? ('fgbcl.games.external.form.already.submitted.title' | translate)
          : ('fgbcl.games.external.form.submit.receive.points.title' | translate)
      }}
    </h2>
    <p class="submission-description text-center">
      {{ 'fgbcl.games.external.form.description' | translate }}
    </p>
    <div 
      class="terms-conditions-checkbox"
      [ngClass]="{ 'terms-checkbox-checked': termsAccepted }"
    >
      <input type="checkbox" id="acceptTerms" class="terms-checkbox" [(ngModel)]="termsAccepted"/>
      <label for="acceptTerms" class="accept-terms-label">{{ 'fgbcl.games.external.form.accept.terms' | translate }}</label>           
    </div>

    <div class="auth-container">
      <button class="auth-login-button" (click)="navigateToLogin()" [disabled]="!termsAccepted" [class.auth-login-button--disabled]="!termsAccepted">{{ 'fgbcl.games.external.form.login.btn' | translate }}</button>
      <button *ngIf="unauthorizedEntityCreated" class="auth-register-button" (click)="navigateToRegistration()" [disabled]="!termsAccepted" [class.auth-register-button--disabled]="!termsAccepted">{{ 'fgbcl.games.external.form.register.btn' | translate }}</button>
    </div>

    <div class="text-center mb-3" *ngIf="!unauthorizedEntityCreated">
      <span class="text-muted">Or</span>
    </div>

    <!-- Form Content -->
    <div class="form-only-container-content">
      <ng-container *ngIf="!unauthorizedEntityCreated">
        <form [formGroup]="unauthorizedForm" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <div class="form-floating">
              <input type="text" class="form-control" id="firstNameForm" placeholder="First Name" formControlName="firstName" />
              <label for="firstNameForm">{{ 'fgbcl.games.external.form.firstname' | translate }}</label>
            </div>
            <span
              class="d-flex mt-1 text-danger font-size-12 mx-2"
              *ngIf="unauthorizedForm.get('firstName')?.touched && unauthorizedForm.get('firstName')?.invalid"
            >
              {{ 'fgbcl.games.external.form.error.firstname.required' | translate }}
            </span>
          </div>

          <div class="mb-3">
            <div class="form-floating">
              <input type="text" class="form-control" id="surnameForm" placeholder="Surname" formControlName="surname" />
              <label for="surnameForm">{{ 'fgbcl.games.external.form.surname' | translate }}</label>
            </div>
            <span
              class="d-flex mt-1 text-danger font-size-12 mx-2"
              *ngIf="unauthorizedForm.get('surname')?.touched && unauthorizedForm.get('surname')?.invalid"
            >
              {{ 'fgbcl.games.external.form.error.surname.required' | translate }}
            </span>
          </div>

          <div class="mb-2">
            <div class="form-floating">
              <input
                type="email"
                class="form-control"
                id="emailForm"
                placeholder="Email Address"
                formControlName="emailAddress"
              />
              <label for="emailForm">{{ 'fgbcl.games.external.form.email' | translate }}</label>
            </div>
            <div
              class="text-danger mb-2 font-size-12 mx-2"
              *ngIf="unauthorizedForm.get('emailAddress')?.touched && unauthorizedForm.get('emailAddress')?.invalid"
            >
              <span class="d-flex mt-1 text-danger" *ngIf="unauthorizedForm.get('emailAddress')?.errors?.['required']">{{
                'fgbcl.games.external.form.error.email.required' | translate
              }}</span>
              <span class="d-flex mt-1 text-danger" *ngIf="unauthorizedForm.get('emailAddress')?.errors?.['email']">{{
                'fgbcl.games.external.form.error.email.invalid' | translate
              }}</span>
            </div>
          </div>

          <div class="form-group">
            <button
              type="submit"
              class="form-submit-button"
              [class.form-submit-button--disabled]="unauthorizedForm.invalid || !termsAccepted"
              [disabled]="unauthorizedForm.invalid || isFormSubmitting || !termsAccepted"
            >
              <span *ngIf="!isFormSubmitting">{{ 'fgbcl.games.external.form.submit.btn' | translate }}</span>
              <span *ngIf="isFormSubmitting">{{ 'fgbcl.games.external.form.submitting.btn' | translate }}</span>
            </button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>

  <!-- Form Only Template -->
  <div *ngSwitchCase="2" class="form-only-container">
    <!-- Form Content -->
    <div class="form-only-container-content">
      <h2 class="submission-title text-center">
        {{
          unauthorizedEntityCreated
            ? ('fgbcl.games.external.form.already.submitted.title' | translate)
            : ('fgbcl.games.external.form.submit.receive.points.title' | translate)
        }}
      </h2>
      <p class="submission-description text-center">
        {{ 'fgbcl.games.external.form.description' | translate }}
      </p>
      <ng-container *ngIf="!unauthorizedEntityCreated; else entityCreated">
        <form [formGroup]="unauthorizedForm" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <div
              class="terms-conditions-checkbox"
              [ngClass]="{ 'terms-checkbox-checked': unauthorizedForm.get('isTermsAccepted')?.value }"
            >
              <input class="terms-checkbox" type="checkbox" id="accepted" formControlName="isTermsAccepted" />
              <label for="accepted" class="accept-terms-label">{{ 'fgbcl.games.external.form.accept.terms' | translate }}</label>
            </div>

            <span
              class="d-flex mt-1 text-danger font-size-12"
              *ngIf="unauthorizedForm.get('isTermsAccepted')?.touched && unauthorizedForm.get('isTermsAccepted')?.invalid"
            >
              {{ 'fgbcl.games.external.form.error.accept.terms' | translate }}
            </span>
          </div>

          <div class="mb-3">
            <div class="form-floating">
              <input type="text" class="form-control" id="firstNameForm" placeholder="First Name" formControlName="firstName" />
              <label for="firstNameForm">{{ 'fgbcl.games.external.form.firstname' | translate }}</label>
            </div>
            <span
              class="d-flex mt-1 text-danger font-size-12 mx-2"
              *ngIf="unauthorizedForm.get('firstName')?.touched && unauthorizedForm.get('firstName')?.invalid"
            >
              {{ 'fgbcl.games.external.form.error.firstname.required' | translate }}
            </span>
          </div>

          <div class="mb-3">
            <div class="form-floating">
              <input type="text" class="form-control" id="surnameForm" placeholder="Surname" formControlName="surname" />
              <label for="surnameForm">{{ 'fgbcl.games.external.form.surname' | translate }}</label>
            </div>
            <span
              class="d-flex mt-1 text-danger font-size-12 mx-2"
              *ngIf="unauthorizedForm.get('surname')?.touched && unauthorizedForm.get('surname')?.invalid"
            >
              {{ 'fgbcl.games.external.form.error.surname.required' | translate }}
            </span>
          </div>

          <div class="mb-2">
            <div class="form-floating">
              <input
                type="email"
                class="form-control"
                id="emailForm"
                placeholder="Email Address"
                formControlName="emailAddress"
              />
              <label for="emailForm">{{ 'fgbcl.games.external.form.email' | translate }}</label>
            </div>
            <div
              class="text-danger mb-2 font-size-12 mx-2"
              *ngIf="unauthorizedForm.get('emailAddress')?.touched && unauthorizedForm.get('emailAddress')?.invalid"
            >
              <span class="d-flex mt-1 text-danger" *ngIf="unauthorizedForm.get('emailAddress')?.errors?.['required']">{{
                'fgbcl.games.external.form.error.email.required' | translate
              }}</span>
              <span class="d-flex mt-1 text-danger" *ngIf="unauthorizedForm.get('emailAddress')?.errors?.['email']">{{
                'fgbcl.games.external.form.error.email.invalid' | translate
              }}</span>
            </div>
          </div>

          <div class="form-group">
            <button
              type="submit"
              class="form-submit-button"
              [class.form-submit-button--disabled]="unauthorizedForm.invalid"
              [disabled]="unauthorizedForm.invalid || isFormSubmitting"
            >
              <span *ngIf="!isFormSubmitting">{{ 'fgbcl.games.external.form.submit.btn' | translate }}</span>
              <span *ngIf="isFormSubmitting">{{ 'fgbcl.games.external.form.submitting.btn' | translate }}</span>
            </button>
          </div>
        </form>
      </ng-container>
      <ng-template #entityCreated>
        <div class="auth-container">
          <button class="auth-login-button" (click)="navigateToLogin()">{{ 'fgbcl.games.external.form.login.btn' | translate }}</button>
          <button class="auth-register-button" (click)="navigateToRegistration()">{{ 'fgbcl.games.external.form.register.btn' | translate }}</button>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
